import React, { useState, useEffect } from "react";
import { getApiCall, postApiCall, patchApiCall, fetchAndSetFlashMessage } from "../../../service/httpCall";
import { Row, Col, Card, Form } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RenderDeleteModal from "../../../components/partials/components/delete-modal";
import ToastNotification from "../../../components/Toast";
import { toast } from 'react-toastify';
import {
  API_VOICE_PLAN_LIST,
  API_VOICE_PLAN_CREATE,
  API_VOICE_PLAN_DELETE,
  API_VOICE_PLAN_EDIT,
} from "../../../service/url";
import { ROUTES } from "../../../utilities/constant";
import { EditIcon, DeleteIcon } from "../../../components/setting/elements";
import Loader  from '../../../components/partials/components/loader';
import { useAuth, errorCheck } from '../auth/auth-utils';
import { useNavigate } from "react-router-dom";
import { USER_ROLES, MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT } from '../../../utilities/constant';
import { getUser } from "../../../utilities/setting";
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import "../../../assets/custom/css/custom.css";
import exportData from '../../../utilities/export';
import { Dropdown } from 'primereact/dropdown';
import { FiTrash2, FiEdit2, FiCheck, FiX } from "react-icons/fi";
import { FaEye } from "react-icons/fa";
import { MdEdit } from "react-icons/md";


const VoicePlanList = () => {
  const navigate = useNavigate();
  const [statusList, setStatusList] = useState({});
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [voicePlan, setVoicePlan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSuperAdmin, checkIsSuperAdmin] = useState(false);
  const [moduleOperations, setModuleOperations] = useState({});
  const [buttonDisable, setButtonDisable] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  const [originalDataList, setOriginalDataList] = useState([]);
  const [selectedDummy, setSelectedDummy] = useState({});

  // Delete modal states
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [planToDelete, setPlanToDelete] = useState(null);
  const [loggedInUserACL, setLoggedInUserACL] = useState({})
  
  // View modal states
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedPlanDetails, setSelectedPlanDetails] = useState(null);
  
  // Edit states
  const [editingPlanId, setEditingPlanId] = useState(null);
  const [editingPlanName, setEditingPlanName] = useState("");
  const [planNameError, setPlanNameError] = useState("");
  const [alertMessage, setAlertMessage] = useState(null);

  const handleExport = async () => {
    setButtonDisable(true); 
    await exportData('VoicePlan', setToastProps, setShowToast);
    setButtonDisable(false); 
  };
 
  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  const fetchVoicePlans = async () => {
    setLoading(true);
    try {
      getApiCall(API_VOICE_PLAN_LIST)
        .then(onVoicePlanSuccess)
        .catch(onError)
        .finally(() => setLoading(false));
    } catch (error) {
      console.error("Error fetching voice plans:", error);
      setLoading(false);
    }
  };

   useEffect(() => {
      getUser().then((user) => {
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
      });
    fetchVoicePlans();
    fetchAndSetFlashMessage(
      msg => msg.module_name === MODULE_ACL.VOICE_PLANS && msg.action === FLASH_MESSAGE_ACTION_OBJECT.LIST && msg.type === 'Flash Message',
      setAlertMessage
      );
   }, []);


  useEffect(() => {
    getUser().then((user) => {
      if (user) {
        if (user.role === USER_ROLES.SUPERADMIN) {
          checkIsSuperAdmin(true);
        }
        if (user?.acl_settings) {
          setModuleOperations(JSON.parse(user.acl_settings.module_operations));
        }
      }
    });
  }, []);

  function onVoicePlanSuccess(resp) {
    const updatedList = resp.map((val, idx) => {
      val["key"] = idx + 1;
      val["req_date"] = new Date(val["req_date"]).toGMTString();
      return val;
    });
    setVoicePlan(updatedList);
    setOriginalDataList(updatedList);
  }

  useEffect(() => {
      if(searchValue){
        setVoicePlan(
          originalDataList.filter((data) => data.plan_name.toLowerCase().includes(searchValue.trim().toLowerCase()))
        );
      }
      else {
        setVoicePlan(originalDataList);
      }
    }, [searchValue]);
 
  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
     console.log(err)
   }
 }

 const handleCreateButtonClick = () => {
  navigate(`/${ROUTES.VOICE_PLAN.CREATE}`);
} 

  if (loading) {
    return <Loader />
 }

    // Handle Status Toggle
    const handleStatusToggle = async (planId, currentStatus) => {
      const newStatus = !currentStatus; // Toggle based on the currentStatus
   
      try {
          await postApiCall(`/v2/voice-plan/${planId}`, { status: newStatus ? 1 : 0 });
   
          setStatusList((prev) => ({
              ...prev,
              [planId]: newStatus,
          }));

          // Update selectedPlanDetails if the modal is showing this plan
          if (selectedPlanDetails && selectedPlanDetails.id === planId) {
            setSelectedPlanDetails((prev) => ({
              ...prev,
              plan_status: newStatus ? 1 : 0
            }));
          }

          // If disabled, remove from the list immediately
          if (!newStatus) {
            setVoicePlan((prev) => prev.filter((plan) => plan.id !== planId));
            setOriginalDataList((prev) => prev.filter((plan) => plan.id !== planId));
          }

          toast.success(`Plan status updated to ${newStatus ? 'Enable' : 'Disable'}`)
      } catch (error) {
          toast.warning(JSON.stringify(error))
      }
   };

   // Confirm delete
   const confirmDelete = (id) => {
     setPlanToDelete(id);
     setDeleteModalVisible(true);
   };

   // Execute delete
   const executeDelete = async () => {
     try {
      const url = `${API_VOICE_PLAN_DELETE}/${planToDelete}`;
       const response = await postApiCall(url);
       if (response) {
         toast.success(response.message || "Voice Plan deleted successfully")
         await fetchVoicePlans();
       } else {
        toast.error(response?.message || "Error deleting voice plan")
       }
     } catch (error) {
       let message = "Error deleting voice plan";
       if (error.response && error.response.data && error.response.data.message && 
           error.response.data.message.toLowerCase().includes('allocated')) {
         message = "Cannot delete this voice plan as it is currently allocated to users.";
       } else {
         message = error.message || error || "Error deleting voice plan";
       }
       toast.error(message)
     } finally {
       setDeleteModalVisible(false);
       setPlanToDelete(null);
     }
   };

   // Handle view plan details
   const handleViewPlan = (planData) => {
     setSelectedPlanDetails(planData);
     setViewModalVisible(true);
   };

   // Handle edit plan name
   const handleEditPlanName = (planData) => {
     setEditingPlanId(planData.id);
     setEditingPlanName(planData.plan_name);
     setPlanNameError("");
   };

   // Handle save plan name
   const handleSavePlanName = async (planId) => {
     // Validate plan name
     if (!editingPlanName.trim()) {
       setPlanNameError("Plan name is required");
       return;
     }
     
     // Check for numbers
     if (!/^[a-zA-Z0-9-_]+$/.test(editingPlanName)) {
      setPlanNameError(
        "Only letters, numbers, hyphen (-), and underscore (_) are allowed. Spaces are not allowed."
      );
      return;
    }

    try {
      const response = await patchApiCall(`${API_VOICE_PLAN_EDIT}/${planId}`, {
        plan_name: editingPlanName.trim()
      });
       
       if (response) {
         toast.success("Plan name updated successfully");
         setEditingPlanId(null);
         setEditingPlanName("");
         setPlanNameError("");
         await fetchVoicePlans();
       }
     } catch (error) {
       toast.error(error.message || error || "Error updating plan name");
     }
   };

   // Handle cancel edit
   const handleCancelEdit = () => {
     setEditingPlanId(null);
     setEditingPlanName("");
     setPlanNameError("");
   };

  return (
    <>
      <div>
        {alertMessage && <div className="alert alert-success marquee-container" style={{ marginTop: "5px" }}>
          <span className="marquee-text">{alertMessage}</span>
        </div>}
        <Row>
          <Col sm="12">
            <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Voice Plans List</h4>
              </div>
              {(isSuperAdmin || loggedInUserACL[MODULE_ACL.VOICE_PLANS]?.add) && (
                <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>
                  Create Voice Plan
                </button>
              )}

            </Card.Header>
              <Card.Body className="px-0">
                <div className="table-responsive border-bottom my-3">
                <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-start"}}>
                  {voicePlan.length > 0 && 
                  <Button 
                     label="Export Data"
                     icon="pi pi-file-export"
                    onClick={handleExport} 
                    className="p-button-active p-button-sm" 
                    style={{ marginBottom: '10px', marginLeft: '10px' }} 
                    disabled={buttonDisable} 
                     >
                    &nbsp;
                   {buttonDisable && (
                   <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                   )}
                  </Button>
                  }

                  <Form.Group style={{height: "45px"}}>
                    <Form.Control
                      style={{height: "50px", marginLeft: "10px", border: "1px solid #ced4da", fontSize: "15px", height: "45px"}}
                      placeholder = 'Search by Plan Name...'
                      type="text"
                      maxLength={100}
                      value={searchValue} 
                      onChange={(e) => setSearchValue(e.target.value)}
                      required
                    />
                  </Form.Group>
                  </div>
                  <div className="scroll-container">
                    <DataTable
                      value={voicePlan}
                      tableStyle={{ minWidth: "50rem" }}
                      paginator
                      rows={8}
                    >
                      <Column
                        field="plan_name"
                        header="Plan Name"
                        body={(rowData) => {
                          if (editingPlanId === rowData.id) {
                            return (
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Form.Control
                                  type="text"
                                  value={editingPlanName}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setEditingPlanName(value);
                                    // Validate on change
                                    if (!/^[a-zA-Z0-9-_]*$/.test(value)) {
                                      setPlanNameError("Only letters, numbers, hyphen (-), and underscore (_) are allowed");
                                    } else {
                                      setPlanNameError("");
                                    }
                                  }}
                                  style={{ width: "200px", display: "inline-block" }}
                                />
                                <button
                                  className="btn btn-sm btn-success"
                                  onClick={() => handleSavePlanName(rowData.id)}
                                  disabled={!!planNameError || !editingPlanName.trim()}
                                  style={{ padding: "4px 8px", display: "flex", alignItems: "center" }}
                                  title="Save"
                                >
                                  <FiCheck style={{ fontSize: "16px" }} />
                                </button>
                                <button
                                  className="btn btn-sm btn-secondary"
                                  onClick={handleCancelEdit}
                                  style={{ padding: "4px 8px", display: "flex", alignItems: "center" }}
                                  title="Cancel"
                                >
                                  <FiX style={{ fontSize: "16px" }} />
                                </button>
                                {planNameError && (
                                  <small className="text-danger" style={{ display: "block", width: "100%", marginTop: "4px" }}>
                                    {planNameError}
                                  </small>
                                )}
                              </div>
                            );
                          }
                          return (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <span>{rowData.plan_name}</span>
                              {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.VOICE_PLANS]?.edit) && (
                                <MdEdit
                                  style={{ color: "#5a6268", cursor: "pointer", fontSize: "18px" }}
                                  onClick={() => handleEditPlanName(rowData)}
                                  title="Edit Plan Name"
                                />
                              )}
                            </div>
                          );
                        }}
                      ></Column>

                      <Column
                        header="Pulse Duration"
                        body={(rowData) => {
                          const durationOptions = rowData.plans.map(p => ({
                            label: `${p.plan_type}: ${p.pulse_duration}`,
                            value: `${p.plan_type}_duration`,
                          }));

                          return (
                            <Dropdown
                              value={null}
                              options={durationOptions}
                              placeholder="Pulse Duration"
                              onChange={() => {}}
                              className="p-button p-button-sm p-button-outlined text-sm"
                              style={{ width: '14rem', height: '2rem', overflow: "hidden" }}
                            />
                          );
                        }}
                      />
                      <Column
                        header="Pulse Price"
                        body={(rowData) => {
                          const priceOptions = rowData.plans.map(p => ({
                            label: `${p.plan_type}: ${p.pulse_price}`,
                            value: `${p.plan_type}_price`,
                          }));

                          return (
                            <Dropdown
                              value={null}
                              options={priceOptions}
                              placeholder="Pulse Price"
                              onChange={() => {}} 
                              className="p-button p-button-sm p-button-outlined text-sm"
                              style={{ width: '12rem', height: '2rem' }}
                            />
                          );
                        }}
                      />
                      {/* <Column
                        field="plan_status"
                        header="Status"
                        body={(rowData) => (rowData.plan_status === 1 ? "Enable" : "Disable")}
                      /> */}
                      <Column
                        field="user.username"
                        header="Created By"
                      ></Column>
                      <Column field="req_date" header="Created Date" body={(rowData) =>
                                    new Date(rowData.req_date).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                      <Column
                        header="Action"
                        body={(rowData) => {
                          const isChecked = statusList[rowData.id] ?? (rowData.plan_status == 1); // Use statusList if set, otherwise plan_status

                          return (
                            <div style={{ display: "flex", gap: "15px", textAlign: 'center', alignItems: "center" }}>
                              <FaEye
                                style={{ color: "#007bff", cursor: "pointer", fontSize: "18px" }}
                                onClick={() => handleViewPlan(rowData)}
                                title="View Plan Details"
                              />
                              <label className="slider_switch">
                                <input
                                  type="checkbox"
                                  checked={isChecked}
                                  onChange={() => handleStatusToggle(rowData.id, isChecked)}
                                />
                                <span className="slider"></span>
                              </label>
                                {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.VOICE_PLANS]?.delete) &&
                                  rowData.is_allocated == 0 && (
                                    <FiTrash2
                                      style={{ color: "#dc3545", cursor: "pointer", fontSize: "18px" }}
                                      onClick={() => confirmDelete(rowData.id)}
                                      title="Delete Plan"
                                    />
                                  )}

                            </div>
                          );
                        }}
                        style={{ width: '10rem', textAlign: 'center' }}
                      />
                    </DataTable>
                  </div>  
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Delete Confirmation Modal */}
      <Dialog
        header="Confirm Delete"
        visible={deleteModalVisible}
        style={{ width: "25vw" }}
        onHide={() => setDeleteModalVisible(false)}
        footer={
          <div>
            <Button
              label="Cancel"
              className="p-button-text"
              onClick={() => setDeleteModalVisible(false)}
            />
            <Button
              label="Delete"
              className="p-button-danger"
              onClick={executeDelete}
            />
          </div>
        }
      >
        <p>Are you sure you want to delete this voice plan?</p>
      </Dialog>

      {/* View Plan Details Modal */}
      <style>
        {`
          .voice-plan-dialog .p-dialog-header-close,
          .voice-plan-dialog .p-dialog-header-close-icon,
          .voice-plan-dialog .p-dialog-header-close-icon span,
          .voice-plan-dialog .p-dialog-header-close-icon .pi,
          .voice-plan-dialog .p-dialog-header-close .pi {
            color: white !important;
          }
          .voice-plan-dialog .p-dialog-header-close:hover,
          .voice-plan-dialog .p-dialog-header-close-icon:hover,
          .voice-plan-dialog .p-dialog-header-close:hover .pi,
          .voice-plan-dialog .p-dialog-header-close-icon:hover .pi,
          .voice-plan-dialog .p-dialog-header-close:hover span,
          .voice-plan-dialog .p-dialog-header-close-icon:hover span,
          .voice-plan-dialog button.p-dialog-header-close:hover .pi,
          .voice-plan-dialog button.p-dialog-header-close:hover span,
          .voice-plan-dialog button.p-dialog-header-close:hover,
          .voice-plan-dialog .p-dialog-header-close:hover * {
            color: #000000 !important;
            opacity: 1 !important;
          }
        `}
      </style>
      <Dialog
        header="Voice Plan Details"
        visible={viewModalVisible}
        className="voice-plan-dialog"
        style={{ width: "55vw", minWidth: "600px" }}
        headerStyle={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          padding: "20px 24px",
          borderRadius: "6px 6px 0 0",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          fontSize: "20px",
          fontWeight: "600",
          letterSpacing: "0.5px",
          border: "none"
        }}
        contentStyle={{ padding: "24px", paddingBottom: "24px" }}
        onHide={() => setViewModalVisible(false)}
      >
        {selectedPlanDetails && (
          <div style={{ padding: "0" }}>
            {/* Plan Information Section */}
            <div style={{
              background: "#f8f9fa",
              padding: "20px",
              borderRadius: "8px",
              marginBottom: "24px",
              border: "1px solid #e9ecef"
            }}>
              <div style={{ marginBottom: "16px" }}>
                <div style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  marginBottom: "6px",
                  fontWeight: "600"
                }}>
                  Plan Name
                </div>
                <div style={{
                  fontSize: "18px",
                  color: "#212529",
                  fontWeight: "600"
                }}>
                  {selectedPlanDetails.plan_name}
                </div>
              </div>

              <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
                marginTop: "20px"
              }}>
                <div>
                  <div style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    fontWeight: "600"
                  }}>
                    Created By
                  </div>
                  <div style={{
                    fontSize: "14px",
                    color: "#212529",
                    fontWeight: "500"
                  }}>
                    {selectedPlanDetails.user?.username || "N/A"}
                  </div>
                </div>

                <div>
                  <div style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "6px",
                    fontWeight: "600"
                  }}>
                    Status
                  </div>
                  <div>
                    {(() => {
                      // Use statusList if available, otherwise use selectedPlanDetails.plan_status
                      const currentStatus = statusList[selectedPlanDetails.id] !== undefined 
                        ? statusList[selectedPlanDetails.id] 
                        : (selectedPlanDetails.plan_status == 1);
                      const isEnabled = currentStatus;
                      
                      return (
                        <span style={{
                          display: "inline-block",
                          padding: "4px 12px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                          background: isEnabled ? "#d4edda" : "#f8d7da",
                          color: isEnabled ? "#155724" : "#721c24"
                        }}>
                          {isEnabled ? "Enabled" : "Disabled"}
                        </span>
                      );
                    })()}
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "20px" }}>
                <div style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  marginBottom: "6px",
                  fontWeight: "600"
                }}>
                  Created Date
                </div>
                <div style={{
                  fontSize: "14px",
                  color: "#212529",
                  fontWeight: "500"
                }}>
                  {new Date(selectedPlanDetails.req_date).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}
                </div>
              </div>
            </div>
            
            {/* Plan Details Table Section */}
            <div style={{marginTop:"-13px"}}>
              <div style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#212529",
                marginBottom: "16px",
                paddingBottom: "10px",
                borderBottom: "2px solid #667eea"
              }}>
                Plan Details
              </div>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered" style={{
                  marginTop: "0",
                  marginBottom: "0",
                  fontSize: "14px"
                }}>
                  <thead style={{
                    background: "#667eea",
                    color: "white"
                  }}>
                    <tr>
                      <th style={{
                        padding: "12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                      }}>
                        Plan Type
                      </th>
                      <th style={{
                        padding: "12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                      }}>
                        Pulse Duration
                      </th>
                      <th style={{
                        padding: "12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px"
                      }}>
                        Pulse Price (paisa)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedPlanDetails.plans && selectedPlanDetails.plans.length > 0 ? (
                      selectedPlanDetails.plans.map((plan, index) => (
                        <tr key={index} style={{
                          background: index % 2 === 0 ? "#ffffff" : "#f8f9fa"
                        }}>
                          <td style={{
                            padding: "12px",
                            fontWeight: "500",
                            color: "#212529"
                          }}>
                            {plan.plan_type}
                          </td>
                          <td style={{
                            padding: "12px",
                            color: "#6c757d"
                          }}>
                            {plan.plan_type === 'MISSED' ? (
                              <span style={{ fontStyle: "italic", color: "#adb5bd" }}>N/A</span>
                            ) : (
                              plan.pulse_duration
                            )}
                          </td>
                          <td style={{
                            padding: "12px",
                            fontWeight: "500",
                            color: "#212529"
                          }}>
                            {plan.pulse_price}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center" style={{
                          padding: "20px",
                          color: "#6c757d",
                          fontStyle: "italic"
                        }}>
                          No plan details available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </Dialog>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </>
  );
};

export default VoicePlanList;